module.exports = __webpack_public_path__ + "res/19-img_card_bg.a76924f1a81aad29fea4f99951332910.png";